// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AddTeam from '../addTeam';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import AddMember from '../addTournamentTeamMember';
import Dialog from 'material-ui/Dialog';
import Chip from 'material-ui/Chip';
import Modal from 'react-modal';
import { colors, btn, modal } from '../../../../style/common/partnerStyle';

class DeleteCompetitionTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      confirmDelete: false,
      deleting: false,
    };
  }

  componentDidMount() {
    // this.getaddTeamInputs();
    // this.getTeamList();
    // this.getTeamDetailInput();
    console.log(this.state);
  }

  toDeleteTeam() {
    this.setState({ deleting: true });
    var mobile_no = this.state.mobile_no;
    const url = `${getLocationOrigin()}/eagleeye/delete_TournamentTeam/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'team_id': this.state.id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        alert(data.message);
        this.props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
        this.setState({ deleting: false });
      });
  }

  handleBack() { this.props.history.goBack(); }

  renderChip(data) {
    return (
      <Chip key={data.id} onRequestDelete={() => this.handleRequestDelete(data)} style={styles.chip}>
        {data.name}
      </Chip>
    );
  }

  render() {
    console.log('Teams');
    console.log(this.state);

    return (
      <Modal
        isOpen={true}
        onRequestClose={() => this.handleBack()}
        style={{
          overlay: { backgroundColor: 'rgba(17,24,39,.45)', zIndex: 1000 },
          content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%,-50%)',
            padding: 0, border: 'none', borderRadius: 16,
            boxShadow: '0 8px 40px rgba(0,0,0,.18)',
            width: '90%', maxWidth: 420,
          },
        }}
      >
        <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", padding: '32px 28px 24px' }}>
          <div style={{ textAlign: 'center', marginBottom: 8, fontSize: 40 }}>🗑️</div>
          <h3 style={modal.confirmTitle}>Delete Team</h3>
          <p style={modal.confirmText}>Are you sure you want to delete this team? This action cannot be undone.</p>
          <div style={modal.confirmFooter}>
            <button type="button" style={btn.cancel} onClick={() => this.handleBack()}>Cancel</button>
            <button
              type="button"
              style={{ ...btn.danger, opacity: this.state.deleting ? 0.6 : 1, cursor: this.state.deleting ? 'not-allowed' : 'pointer' }}
              disabled={this.state.deleting}
              onClick={() => this.toDeleteTeam()}
            >
              {this.state.deleting ? 'Deleting…' : 'Delete'}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default DeleteCompetitionTeam;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/deleteCompetitionTeam/index.js